import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EvolutionInstanceInfo} from '@gatewee/types/evolution';

@Injectable({
  providedIn: 'root',
})
export class WhatsappService {
  constructor(public http: HttpClient) {}

  getWhatsapp() {
    return this.http.get<EvolutionInstanceInfo>(
      '/communications/recipient/whatsapp',
    );
  }

  connectWhatsapp() {
    return this.http.post('/communications/recipient/whatsapp', {});
  }

  disconnectInstance() {
    return this.http.delete('/communications/recipient/whatsapp');
  }

  sendTestMessage(phone: string) {
    return this.http.post(
      '/communications/recipient/whatsapp/test-message/' + phone,
      {},
    );
  }
}
